var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsClockwiseBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.061 22.939a1.503 1.503 0 010 2.125c-.141.14-3.5 3.439-9.061 3.439-4.214 0-7.419-2.183-9.5-4.233V26a1.5 1.5 0 01-3 0v-6A1.5 1.5 0 015 18.5h6a1.5 1.5 0 110 3H8.015c1.637 1.79 4.385 4 7.985 4 4.329 0 6.914-2.535 6.939-2.561a1.5 1.5 0 012.122 0zM27 4.5A1.5 1.5 0 0025.5 6v1.732C23.419 5.683 20.214 3.5 16 3.5c-5.557 0-8.92 3.299-9.061 3.439a1.503 1.503 0 002.125 2.125C9.086 9.035 11.67 6.5 16 6.5c3.6 0 6.348 2.21 7.985 4H21a1.5 1.5 0 100 3h6a1.5 1.5 0 001.5-1.5V6A1.5 1.5 0 0027 4.5z"
  })));
}
export default SvgArrowsClockwiseBold;